<script>
  export let x;
  export let y;
  export let req;
</script>

<use xlink:href={`#Sym-${req}`} {x} {y} width="0.8" height="0.8" />
